import http from '../../../../utils/http.js'

/*
 * @DESC:api接口
 */
const GET_SHOP_TRADE = "admin/getShopTrade";//获取门店交易流水


export default {
	getShopTrade: ({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return new Promise((resolve, reject) => {
			http.get(GET_SHOP_TRADE, params)
				.then((res = null) => {
					
						commit('GET_SHOP_TRADE',res) // 后台获得全部数据
					
					resolve(res);
				},(err)=>{
					reject(err.message)
				})
		})
	},
	
}


// WEBPACK FOOTER //
// ./src/store/mp/pay_manage/data_analyse/actions.js